"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextStrikethrough = _interopRequireDefault(require("@react/react-spectrum/Icon/TextStrikethrough"));

var _Draw = _interopRequireDefault(require("@react/react-spectrum/Icon/Draw"));

var _PinOff = _interopRequireDefault(require("@react/react-spectrum/Icon/PinOff"));

var _Icon = _interopRequireDefault(require("@react/react-spectrum/Icon"));

var _svgs = require("../../lib/svgs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var AnnotationMarker = function AnnotationMarker(_ref) {
  var annotationTypes = _ref.annotationTypes,
      pinNum = _ref.pinNum,
      hasShapeAnnotation = _ref.hasShapeAnnotation,
      hasHighlightAnnotation = _ref.hasHighlightAnnotation,
      hasInsertAnnotation = _ref.hasInsertAnnotation,
      hasReplaceAnnotation = _ref.hasReplaceAnnotation,
      hasStrikethroughAnnotation = _ref.hasStrikethroughAnnotation,
      strokeColor = _ref.strokeColor,
      visible = _ref.visible;

  if (!visible) {
    return null;
  }

  var annotationMarker = null;
  var annotationStyles = {
    backgroundColor: strokeColor
  };

  if ((!annotationTypes || annotationTypes && annotationTypes.pin) && pinNum) {
    var content = pinNum;

    if (annotationTypes) {
      content = /*#__PURE__*/_react.default.createElement(_PinOff.default, {
        size: "XS"
      });

      if (!annotationStyles.backgroundColor) {
        annotationStyles = {
          backgroundColor: '#B80000'
        };
      }
    } else {
      annotationStyles = {};
    }

    annotationMarker = /*#__PURE__*/_react.default.createElement("span", {
      className: "annotation-marker",
      "data-test": "pin-badge",
      style: annotationStyles
    }, content);
  } else if (annotationTypes && annotationTypes.draw && hasShapeAnnotation) {
    annotationMarker = /*#__PURE__*/_react.default.createElement("span", {
      className: "annotation-marker",
      style: annotationStyles
    }, /*#__PURE__*/_react.default.createElement(_Draw.default, {
      "data-test": "draw-badge",
      size: "XS"
    }));
  } else if (annotationTypes && annotationTypes.highlight && hasHighlightAnnotation) {
    annotationMarker = /*#__PURE__*/_react.default.createElement("span", {
      className: "annotation-marker",
      style: annotationStyles
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      "data-test": "highlight-badge",
      size: "XS"
    }, _svgs.highlightIcon));
  } else if (annotationTypes && annotationTypes.strikethrough && hasStrikethroughAnnotation) {
    annotationMarker = /*#__PURE__*/_react.default.createElement("span", {
      className: "annotation-marker",
      style: annotationStyles
    }, /*#__PURE__*/_react.default.createElement(_TextStrikethrough.default, {
      "data-test": "strikethrough-badge",
      size: "XS"
    }));
  } else if (annotationTypes && annotationTypes.insert && hasInsertAnnotation) {
    annotationMarker = /*#__PURE__*/_react.default.createElement("span", {
      className: "annotation-marker",
      style: annotationStyles
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      "data-test": "insert-badge",
      size: "XS"
    }, _svgs.insertIcon));
  } else if (annotationTypes && annotationTypes.replace && hasReplaceAnnotation) {
    annotationMarker = /*#__PURE__*/_react.default.createElement("span", {
      className: "annotation-marker",
      style: annotationStyles
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      "data-test": "replace-badge",
      size: "XS"
    }, _svgs.replaceIcon));
  }

  return annotationMarker;
};

AnnotationMarker.defaultProps = {
  pinNum: undefined,
  hasShapeAnnotation: false,
  hasHighlightAnnotation: false,
  hasInsertAnnotation: false,
  hasReplaceAnnotation: false,
  hasStrikethroughAnnotation: false,
  strokeColor: '',
  visible: false
};
AnnotationMarker.propTypes = {
  pinNum: _propTypes.default.number,
  hasShapeAnnotation: _propTypes.default.bool,
  hasHighlightAnnotation: _propTypes.default.bool,
  hasInsertAnnotation: _propTypes.default.bool,
  hasReplaceAnnotation: _propTypes.default.bool,
  hasStrikethroughAnnotation: _propTypes.default.bool,
  strokeColor: _propTypes.default.string,
  visible: _propTypes.default.bool
};
var _default = AnnotationMarker;
exports.default = _default;